import { useEffect, useState } from 'react';
import { globalSearch, isCanceled } from './api';
import type { SearchGroup } from './types';

const DEBOUNCE_MS = 150;

export interface GlobalSearchState {
  groups: SearchGroup[];
  loading: boolean;
  error: boolean;
}

export function useGlobalSearch(query: string, types: string[]): GlobalSearchState {
  const [state, setState] = useState<GlobalSearchState>({ groups: [], loading: false, error: false });
  const typesKey = types.join(',');
  const q = query.trim();

  useEffect(() => {
    if (!q || !typesKey) {
      setState({ groups: [], loading: false, error: false });
      return undefined;
    }
    const controller = new AbortController();
    setState((s) => ({ ...s, loading: true, error: false }));
    const timer = setTimeout(() => {
      globalSearch(q, typesKey.split(','), controller.signal)
        .then((data) => {
          if (controller.signal.aborted) return;
          setState({ groups: data.groups, loading: false, error: false });
        })
        .catch((err) => {
          if (controller.signal.aborted || isCanceled(err)) return;
          setState((s) => ({ ...s, loading: false, error: true }));
        });
    }, DEBOUNCE_MS);
    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [q, typesKey]);

  return state;
}
